var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-line"},[_c('div',{staticClass:"background-box",style:({
      // top: smallTop,
      height: `${_vm.barHeight}vw`,
    })}),_c('div',{staticClass:"color-box",class:{
      left: _vm.position === 'left',
      right: _vm.position === 'right',
    },style:({
      width: _vm.smallWidth,
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }